import environment from "environment";
import EffectUtility from "../../utilities/EffectUtility";
import LocationgetModel from "./model/LocationgetModel";

// LocationEffect
export default class LocationEffect {
  // calling an API according to the status model
  static async requestLocation(params) {
    const endpoint = environment.api.location;
    return EffectUtility.getToModel(LocationgetModel, endpoint, params);
  }
}
